'use client';

import { useEffect } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { InternalServerErrorIcon } from '../../icons/internalServerError';

interface Props {
  returnTo: string;
}

declare global {
  interface Window {
    sa_event?: any;
  }
}

export function InternalClientError({ returnTo }: Props) {
  useEffect(() => {
    document.title = `CloudQuery | We're sorry`;

    if (typeof window === 'undefined' || typeof window.sa_event !== 'function') {
      return;
    }
    const data = { path: window.location.pathname };
    window.sa_event('500', data);
  }, []);

  return (
    <Box alignItems="center" component="main" display="flex" flexGrow={1} paddingY={10}>
      <Container maxWidth="xl">
        <Box display="flex" justifyContent="center" marginBottom={3}>
          <InternalServerErrorIcon sx={{ height: 128, width: 'auto' }} />
        </Box>
        <Typography align="center" marginBottom={1} variant="h5">
          Unexpected error
        </Typography>
        <Typography
          align="center"
          marginBottom={3}
          sx={{ color: 'text.secondary' }}
          variant="body1"
        >
          You can go back to the home page and try again.
        </Typography>
        <Box display="flex" justifyContent="center" marginBottom={6}>
          <Button
            component={'a'} // hard link to force a full page reload and data refresh
            endIcon={<ChevronRightIcon />}
            href={returnTo ?? '/'}
            size="medium"
            variant="contained"
          >
            Take Me Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
